/* eslint-disable no-unused-vars */
import { createStore } from 'vuex';
import _ from 'lodash';
import qs from 'qs';
import moment from 'moment';
import axios from 'axios';
import feathersClient from '../feathers-client';

import { constants } from '@/helpers/constants';
import {
	jobRatesTypes,
	jobStatusTypes,
	dateRangeTypes,
} from '@/constants/jobFilter';

import menuStore from './menu';
import dashboardStore from './dashboard';
import messengerStore from './messenger';
import timeTrack from './timeTrack';
import jobRates from './jobRates';
import skillsTable from './skillsTable';
import optionStore from './options';
import staffPersonaStore from './staffPersona';
import spMappingStore from './staffPersonaMapping';
import jobTemplateStore from './jobTemplate';
import skillsStore from './masterySkills';
import jobPostingStore from './jobposting';
import jtMappingStore from './jobTemplateMapping';
import tagStore from './tags';
import organizationStore from './organization';
import rightToWorkRequestsStore from './rightToWorkRequests';
import usersStore from './users';
import modelJobStore from './modeljobs';
import jobMatchScore from './jobMatchStore';
import managerStore from './managers';
import feedbackStore from './feedbacks';
import preferenceStore from './preferences';
import nurseUsersStore from './nurseUsers';
import interventionStore from './intervention';
import shiftInterventionStore from './shiftIntervention';
import shiftInterventionReasonStore from './shiftInterventionReason';
import blockedReasonStore from './blockedReason';
import autoOfferStore from './autoOfferConfiguration';
import notificationStore from './notification';
import appVersionStore from './appVersions';
import privacyPolicyStore from './privacyPolicy';
import configurationStore from './configuration';
import bandMappingStore from './bandMapping';
import endorsementRequestStore from './endorsementRequest';
import { firebaseAuth, initFirebaseDbConnection } from '../firebase';
import shiftTimeStore from './shiftTime';
import payRateStore from './ratPay';
import hiFiAwardReasonStore from './hiFiAwardReason';
import { roleCheck } from '../constants/roleCheck';
import trustRoleStore from './roles';
import rateEscalationChecklistStore from './rateEscalationChecklist';
import approvedReasonsConfigurationStore from './approvedReasonsConfiguration';
import rejectReasonsConfigurationStore from './rejectReasonsConfiguration';
import tierMappingStore from './tierMapping';
import shiftPlansStore from './shiftPlans';
import reportCanellationReasonStore from './reportCanellationReason';
import rosterAvailabilityStore from './rosterAvailability';
import jobPredictionStore from './jobPredictionConfiguration';
import hiFiAwardsStore from './hiFiAwards';
import jobTitleTypeStore from './roleType';
import substantiveUserStore from './substantiveUsers';
import syncUserHistoryStore from './syncUsersHistory';
import syncOnboardUserHistoryStore from './syncOnboardUsersHistory';
import unMappedUsersStore from './unMappedUsers';
import onBoardedUsersStore from './onBoardedUsers';
import unfilledNudgeTimeStore from './unfilledShiftsNudgeTimer';
import unfilledShiftReasonStore from './unfilledShiftsReason';
import staffRedeploymentReasonStore from './StaffRedeploymentReasons';
import staffPersonasMappingStore from './personasMapping';
import neoStore from './neo';
import favoriteSkillsStore from './favoriteSkills';
import staffStore from './staff';
import skillTreeStore from './skillTree';
import autoAcceptanceTimer from './autoAcceptanceTimerConfiguration';
import uploadRosterShifts from './uploadRosterShifts';
import filledShiftReasonStore from './filledShiftConfiguration';
import redeploymentStore from './redeployment';
import swapRequestStore from './swapRequest';
import skillVisualizationReportStore from './skillVisualizationReport';

const accountLocal = JSON.parse(window.localStorage.getItem('account'));
const currentInstitutionId = window.localStorage.getItem(
	'currentInstitutionId',
);

const defaultPagination = {
	total: 100,
	skip: 0,
	limit: 10,
};

const defaultThresholdFactorsPagination = {
	total: 100,
	skip: 0,
	limit: 5,
};

const defaultDepartmentsPagination = {
	total: 100,
	skip: 0,
	limit: 7,
};

const defaultPredictionsPagination = {
	total: 100,
	skip: 0,
	limit: 10,
};

const defaultJobsPagination = {
	total: 100,
	$skip: 0,
	$limit: 6,
};

const defaultJobsFilter = {
	institutionIds: [],
	$dateFrom: moment().format('YYYY-MM-DD'),
	$dateTo: moment().format('YYYY-MM-DD'),
	skills: [],
	areas: [],
	status: jobStatusTypes.VACANT,
	rateStatus: jobRatesTypes.ALL,
	tiers: [],
	fulfillmentType: [],
	$skip: defaultJobsPagination.$skip,
	$limit: defaultJobsPagination.$limit,
};

const defaultThresholdFactorsFilter = {
	skip: defaultThresholdFactorsPagination.skip,
	limit: defaultThresholdFactorsPagination.limit,
};

const defaultDepartmentsFilter = {
	skip: defaultDepartmentsPagination.skip,
	limit: defaultDepartmentsPagination.limit,
};

const defaultPredictionsFilter = {
	skip: defaultPredictionsPagination.skip,
	limit: defaultPredictionsPagination.limit,
};

const defaultUserPagination = {
	total: 100,
	skip: 0,
	limit: 10,
};

const defaultOfferApplicableUserPagination = {
	total: 100,
	skip: 0,
	limit: 10,
};

const defaultUserFilter = {
	skip: defaultUserPagination.skip,
	limit: defaultUserPagination.limit,
};

const defaultOfferApplicableUserFilter = {
	skip: defaultOfferApplicableUserPagination.skip,
	limit: defaultOfferApplicableUserPagination.limit,
};

const store = createStore({
	modules: {
		menu: menuStore,
		dashboard: dashboardStore,
		messenger: messengerStore,
		timeTrack,
		jobRates,
		skillsTable,
		optionStore,
		staffPersonaStore,
		spMappingStore,
		jobTemplateStore,
		skillsStore,
		jobPostingStore: jobPostingStore,
		jtMappingStore,
		tagStore,
		organizationStore,
		rightToWorkRequestsStore,
		usersStore: usersStore,
		jobMatchScore,
		modelJobStore,
		managerStore,
		feedbackStore,
		preferenceStore,
		nurseUsersStore,
		interventionStore,
		shiftInterventionStore,
		blockedReasonStore,
		shiftInterventionReasonStore,
		autoOfferStore,
		notificationStore,
		appVersionStore,
		privacyPolicyStore,
		configurationStore,
		bandMappingStore,
		shiftTimeStore,
		payRateStore,
		hiFiAwardReasonStore,
		endorsementRequestStore,
		trustRoleStore:trustRoleStore,
		rateEscalationChecklistStore,
		approvedReasonsConfigurationStore,
		rejectReasonsConfigurationStore,
		tierMappingStore,
		shiftPlansStore,
		reportCanellationReasonStore,
		rosterAvailabilityStore,
		jobPredictionStore,
		hiFiAwardsStore,
		jobTitleTypeStore,
		substantiveUserStore,
		syncUserHistoryStore,
		syncOnboardUserHistoryStore,
		unMappedUsersStore,
		onBoardedUsersStore,
		unfilledNudgeTimeStore,
		unfilledShiftReasonStore,
		staffRedeploymentReasonStore,
		staffPersonasMappingStore,
		neoStore,
		favoriteSkillsStore,
		staffStore,
		skillTreeStore,
		autoAcceptanceTimerStore: autoAcceptanceTimer,
		uploadRosterShiftsStore: uploadRosterShifts,
		filledShiftReasonStore,
		redeploymentStore,
		swapRequestStore,
		skillVisualizationReportStore
	},
	state: {
		bases: {
			api: __env.API_URL,
		},
		selectedStaffHospital: null,
		initLoading: true,

		users: [],
		offerApplicableUsers: [],
		jobs: [],

		thresholdFactors: [],
		departments: [],
		predictions: [],
		institutions: [],

		path: '/',
		jobsUnfilled: {},
		options: {},
		account: accountLocal,
		isLogged: false,
		trainHospitalActive: false,
		currentInstitutionId:
			currentInstitutionId
			|| (accountLocal ? accountLocal.managerDefaultInstitutionId : null),
		firebaseDb: null,
		jobsForApproval: [],
		selectedJob: null,
		rangeType: dateRangeTypes.selectedDay,
		jobsFilter: defaultJobsFilter,
		thresholdFactorsFilter: defaultThresholdFactorsFilter,
		departmentsFilter: defaultDepartmentsFilter,
		predictionsFilter: defaultPredictionsFilter,
		jobsPagination: defaultJobsPagination,
		thresholdFactorsPagination: defaultThresholdFactorsPagination,
		departmentsPagination: defaultDepartmentsPagination,
		predictionsPagination: defaultPredictionsPagination,
		scrollIsHidden: false,
		selectedCalendarDate: null,
		searchUserResults: [],
		searchUserLoading: false,
		predictionsLoading: false,
		userFilter: defaultUserFilter,
		userPagination: defaultUserPagination,
		approvedUserPagination: defaultUserPagination,
		pendingUserPagination: defaultUserPagination,
		declinedUserPagination: defaultUserPagination,
		bannedUserPagination: defaultUserPagination,
		changedUserPagination: defaultUserPagination,
		offerApplicableUserFilter: defaultOfferApplicableUserFilter,
		offerApplicableUserPagination: defaultOfferApplicableUserPagination,
		currentUserRole: '', // the roleId
		currentUserRolePermissions: [],
		permissionErrors: [],
		jobShiftStatus:'APPROVED',
	},
	getters: {
		selectedStaffHospital: (state) => state.selectedStaffHospital,
		users: (state) => state.users,
		offerApplicaleUsers: (state) => state.offerApplicaleUsers,
		initLoading: (state) => state.initLoading,
		jobs: (state) => state.jobs,
		thresholdFactors: (state) => state.thresholdFactors,
		departments: (state) => state.departments,
		predictions: (state) => state.predictions,
		bases: (state) => state.bases,
		options: (state) => state.options,

		path: (state) => state.path,
		institutions: (state) => state.institutions || [],
		account: (state) => state.account,
		currentUserRole: (state) => state.currentUserRole,
		currentUserRolePermissions: (state) => state.currentUserRolePermissions,
		jobsUnfilled: (state) => state.jobsUnfilled,
		isLogged: (state) => state.isLogged,
		currentInstitutionId: (state) => state.currentInstitutionId,
		trainHospitalActive: (state) => state.trainHospitalActive,
		managerInstitutions: (state) => {
			if (state.account.role === 'admin') return state.institutions;
			return _.intersectionBy(
				state.institutions,
				state.account.managerInstitutions,
				'id',
			);
		},
		firebaseDb: (state) => state.firebaseDb,
		jobsFilter: (state) => state.jobsFilter,
		jobsPage: (state) => {
			const { $limit, $skip } = state.jobsPagination;
			return $skip / $limit + 1;
		},
		selectedCalendarDate: (state) => state.selectedCalendarDate,

		thresholdFactorsPage: (state) => {
			const { limit, skip } = state.thresholdFactorsPagination;
			return skip / limit + 1;
		},
		departmentsPage: (state) => {
			const { limit, skip } = state.departmentsPagination;
			return skip / limit + 1;
		},
		predictionsPage: (state) => {
			const { limit, skip } = state.predictionsPagination;
			return skip / limit + 1;
		},
		userPage: (state) => {
			const { limit, skip } = state.userPagination;
			return skip / limit + 1;
		},
		offerApplicableUserPage: (state) => {
			const { limit, skip } = state.offerApplicableUserPagination;
			return skip / limit + 1;
		},
		approvedUserPage: (state) => {
			const { limit, skip } = state.approvedUserPagination;
			return skip / limit + 1;
		},
		pendingUserPage: (state) => {
			const { limit, skip } = state.pendingUserPagination;
			return skip / limit + 1;
		},
		declinedUserPage: (state) => {
			const { limit, skip } = state.declinedUserPagination;
			return skip / limit + 1;
		},
		bannedUserPage: (state) => {
			const { limit, skip } = state.bannedUserPagination;
			return skip / limit + 1;
		},
		changedUserPage: (state) => {
			const { limit, skip } = state.changedUserPagination;
			return skip / limit + 1;
		},
		getCurrentUserRole: (state) => (institutionId) => (state.account.role === 'admin'
			? 'admin'
			: _.get(
				_.find(state.account.approvals, { institutionId }),
				'role',
				  )),
	},
	mutations: {
		// TOGGLE_IS_NOTIFICATIONS_OPEN: (state) => { state.isNotificationsOpen = !state.isNotificationsOpen; },
		SET_JOBS_SHIFT_STATUS: (state,data) => {state.jobShiftStatus = data},
		SET_CURENT_USER_ROLE_PERMISSIONS: (state, data) => { state.currentUserRolePermissions = data; },
		SET_IS_LOGGED: (state, isLogged) => {
			state.isLogged = isLogged;
		},
		SET_CURRENT_USER_ROLE: (state, role) => {
			state.currentUserRole = role;
		},
		SET_ACCOUNT: (state, account) => {
			state.account = account;
		},
		UPDATE_ACCOUNT: (state, updatedAccount) => {
			state.account = { ...state.account, ...updatedAccount };
		},
		SET_STAFF_SELECTED_HOSPITAL: (state, hospital) => {
			state.selectedStaffHospital = hospital;
		},
		REFRESH_OFFER: (state, payload) => {
			state.jobs[payload.index] = payload.job;
			state.jobs.splice(0, 0);
		},
		SET_USERS: (state, users) => {
			state.users = users;
		},
		SET_OFFER_APPLICABLE_USERS: (state, offerApplicableUsers) => {
			state.offerApplicableUsers = offerApplicableUsers;
		},
		SET_USER_FILTER: (state, filter) => { state.userFilter = { ...state.userFilter, ...filter }; },
		SET_DEFAULT_USER_FILTER: (state, filter) => { state.userFilter = { ...filter, ...defaultUserFilter }; },
		SET_USER_PAGINATION: (state, data) => { state.userPagination = { ...state.userPagination, ...data }; },
		SET_OFFER_APPLICABLE_USER_FILTER: (state, filter) => { state.offerApplicableUserFilter = { ...state.offerApplicableUserFilter, ...filter }; },
		SET_DEFAULT_OFFER_APPLICABLE_USER_FILTER: (state, filter) => { state.offerApplicableUserFilter = { ...filter, ...defaultOfferApplicableUserFilter }; },
		SET_OFFER_APPLICABLE_USER_PAGINATION: (state, data) => { state.offerApplicableUserPagination = { ...state.offerApplicableUserPagination, ...data }; },
		SET_APPROVED_USER_PAGINATION: (state, data) => { state.approvedUserPagination = { ...state.approvedUserPagination, ...data }; },
		SET_PENDING_USER_PAGINATION: (state, data) => { state.pendingUserPagination = { ...state.pendingUserPagination, ...data }; },
		SET_DECLINED_USER_PAGINATION: (state, data) => { state.declinedUserPagination = { ...state.declinedUserPagination, ...data }; },
		SET_BANNED_USER_PAGINATION: (state, data) => { state.bannedUserPagination = { ...state.bannedUserPagination, ...data }; },
		SET_CHANGED_USER_PAGINATION: (state, data) => { state.changedUserPagination = { ...state.changedUserPagination, ...data }; },
		SET_TRAIN_HOSPITAL_STATUS: (state, trainHospitalActive) => {
			state.trainHospitalActive = trainHospitalActive;
		},

		SET_OPTIONS: (state, options) => {
			state.options = options;
		},
		SET_JOBS: (state, jobs) => {
			state.jobs = [...jobs];
		},
		UPDATE_JOB: (state, payload) => {
			state.jobs[payload.index] = payload.job;
		},
		HIDE_JOB: (state, jobId) => {
			state.jobs = state.jobs.filter((job) => job.id !== jobId);
		},

		SET_THRESHOLD_FACTORS: (state, thresholdFactors) => {
			state.thresholdFactors = [...thresholdFactors];
		},
		SET_DEPARTMENTS: (state, departments) => {
			state.departments = [...departments];
		},
		SET_PREDICTIONS: (state, predictions) => {
			state.predictions = [...predictions];
		},
		SET_JOBS_UNFILLED: (state, jobs) => {
			state.jobsUnfilled = jobs;
		},
		UPDATE_JOBS_PARAMS: (state, data) => {
			const { key, value } = data;
			value.forEach((item) => {
				const index = state.jobs.findIndex(
					(job) => job.id === item.jobId,
				);
				if (index > -1) {
					state.jobs[index][key] = item;
				}
			});
		},
		SET_SCROLL_HIDDEN_STATUS: (state, options) => {
			state.scrollIsHidden = options;
		},
		UPDATE_RATE_ESCALATION: (state, data) => {
			const { index, value } = data;
			if (!state.jobs[index]?.rateEscalation) {
				state.jobs[index].rateEscalation = {
					value,
				};
			} else {
				state.jobs[index].rateEscalation.value = value;
			}
		},
		CLEAR_JOBS: (state) => {
			state.jobs = [];
		},
		SET_PATH: (state, path) => {
			state.path = path;
		},
		SET_INSTITUTIONS: (state, institutions) => {
			state.institutions = institutions;
		},
		SET_SKILLS: (state, skills) => {
			state.skills = skills;
		},
		SET_CURRENT_INSTITUTION_ID: (state, id) => {
			state.currentInstitutionId = id;
		},
		SET_FIREBASE_DB: (state, db) => {
			state.firebaseDb = db;
		},
		SET_INITIAL_LOADING_START: (state) => {
			state.initLoading = true;
		},
		SET_INITIAL_LOADING_COMPLETED: (state) => {
			state.initLoading = false;
		},
		SET_JOBS_FOR_APPROVAL: (state, jobs) => {
			state.jobsForApproval = jobs;
		},
		SET_SELECTED_JOB: (state, job) => {
			state.selectedJob = job;
		},
		SET_RANGE_TYPE: (state, rangeType) => {
			state.rangeType = rangeType;
		},
		SET_JOBS_FILTER: (state, filter) => {
			state.jobsFilter = { ...state.jobsFilter, ...filter };
		},

		SET_THRESHOLD_FACTORS_FILTER: (state, filter) => {
			state.thresholdFactorsFilter = {
				...state.thresholdFactorsFilter,
				...filter,
			};
		},
		SET_DEPARTMENTS_FILTER: (state, filter) => {
			state.departmentsFilter = { ...state.departmentsFilter, ...filter };
		},
		SET_PREDICTIONS_FILTER: (state, filter) => {
			state.predictionsFilter = { ...state.predictionsFilter, ...filter };
		},
		UPDATE_JOBS_FILTER_BY_KEY: (state, data) => {
			const { key, value } = data;
			state.jobsFilter = { ...state.jobsFilter, [key]: value };
		},
		SET_DEFAULT_JOBS_FILTER: (state, filter) => {
			state.jobsFilter = { ...filter, ...defaultJobsFilter };
		},
		SET_JOBS_PAGINATION: (state, data) => {
			state.jobsPagination = { ...state.jobsPagination, ...data };
		},
		SET_SKILLS_FILTER: (state, filter) => {
			state.skillsFilter = { ...filter };
		},
		SET_CALENDAR_DATE: (state, date) => {
			state.selectedCalendarDate = date;
		},

		SET_DEFAULT_THRESHOLD_FACTORS_FILTER: (state, filter) => {
			state.thresholdFactorsFilter = {
				...filter,
				...defaultThresholdFactorsFilter,
			};
		},
		SET_DEFAULT_DEPARTMENTS_FILTER: (state, filter) => {
			state.departmentsFilter = {
				...filter,
				...defaultDepartmentsFilter,
			};
		},
		SET_DEFAULT_PREDICTIONS_FILTER: (state, filter) => {
			state.predictionsFilter = {
				...filter,
				...defaultPredictionsFilter,
			};
		},

		SET_THRESHOLD_FACTORS_PAGINATION: (state, data) => {
			state.thresholdFactorsPagination = {
				...state.thresholdFactorsPagination,
				...data,
			};
		},
		SET_DEPARTMENTS_PAGINATION: (state, data) => {
			state.departmentsPagination = {
				...state.departmentsPagination,
				...data,
			};
		},
		SET_PREDICTIONS_PAGINATION: (state, data) => {
			state.predictionsPagination = {
				...state.predictionsPagination,
				...data,
			};
		},
		SET_SEARCH_USER_RESULTS: (state, data) => {
			state.searchUserResults = data;
		},
		SET_SEARCH_USER_LOADING: (state, data) => {
			state.searchUserLoading = data;
		},
		SET_PREDICTIONS_LOADING: (state, data) => {
			state.predictionsLoading = data;
		},
		SET_PERMISSIONS_ERROR: (state, data) => {
			state.permissionErrors = data;
		},

	},
	actions: {
		showError: async ({ commit, state }, data) => {
			state.permissionErrors.push(data);
			commit('SET_PERMISSIONS_ERROR', state.permissionErrors);
		},
		authManagementCreate: async (context, data) => {
			const url = '/api/v3/authmanagement';
			const results = await feathersClient.service(url).create(data);
			return results;
		},
		getRolePermissions: async ({ commit }, result) => {
			const currentRoleLocal = window.localStorage.getItem('currentUserRole');
			const filterRole = result.user?.rolePermissions?.filter((item) => item.roleId === currentRoleLocal);
			const permissionsValue = filterRole?.map((item) => item.permission?.value);
			// const findIndex = permissionsValue.findIndex(item => item === 'VIEW_WEIGHT_ADJUSTER_SCALE')
			// permissionsValue.splice(findIndex, 1)
			commit('SET_CURENT_USER_ROLE_PERMISSIONS', permissionsValue);
		},
		loadRateJobs: async ({ commit, rootGetters ,state}, filter) => {
			let operationalManager;
			let rateManager;
			let shiftManager;
			let fields = ['applications', 'careLocations', 'manager','rateEscalationHistory','hardToFill','rateEscalationComments','jobPersona']
			if(rootGetters?.currentUserRolePermissions.includes('RATE_ESCALATION_INTERMEDIATE_APPROVAL') || rootGetters?.currentUserRolePermissions.includes('VIEW_NON_PARTICIPANTS_SHIFTS')){
				 fields.push('operationalManager');
			} else if (rootGetters?.currentUserRolePermissions.includes('RATE_ESCALATION_APPROVAL') || rootGetters?.currentUserRolePermissions.includes('VIEW_RATE_ESCALATED_SHIFTS')) {
				fields.push('rateManager');
			} else if (!rootGetters?.currentUserRolePermissions.includes('RATE_ESCALATION_APPROVAL') && !rootGetters?.currentUserRolePermissions.includes('RATE_ESCALATION_INTERMEDIATE_APPROVAL') && rootGetters?.currentUserRolePermissions.includes('ESCALATE_RATE_FOR_A_SHIFT')) {
				fields.push('shiftManager');
			} else {
				fields.push('shiftManager');
			}

			const url = '/api/v3/jobs';
			const status = filter.status;

			if (status && status !== undefined && status !== null) {
				delete filter.$managerBooked;
				delete filter.$managerCompleted;
				delete filter.$vacant;
				delete filter.$status;
				if (status === 'noLog' || status === 'readyForApprove' || status === 'approved') {
					filter.$managerCompleted = true;
					filter.$status = status;
				} else if (status === 'booked') {
					filter.$managerBooked = true;
				} else {
					filter.$vacant = true;
				}
			} else {
				filter.$vacant = true;
			} // shhift-manager
			filter.shiftStatus = state.jobShiftStatus
			 await feathersClient.service(url).find({
				query: {
					$role: rootGetters.currentUserRole,
					$personaNameWithCapability: true,
					fields: fields,
					...filter,
				},
			}).then((results) => {
				commit('SET_JOBS', results.data);
			 const totalCount = results.total;
			
				commit('SET_JOBS_PAGINATION', { total: totalCount });
			});
		},
		authLogin: async ({ commit, dispatch }, user) => {
			try {
				
				const url = '/api/v3/authentication';
				const results = await feathersClient.authenticate({
					...user,
					email: user.email.toLowerCase(),
					strategy: 'cognito_auth',
				});
				commit('SET_INITIAL_LOADING_START');
				window.localStorage.setItem('token', results.accessToken);
				
				const account = results.user;
				commit('SET_ACCOUNT', account);
				window.localStorage.setItem('account', JSON.stringify(account));
				const result = roleCheck(account.newUserRoles);
				if (result) {
					commit('SET_CURRENT_USER_ROLE', result.roleId);
					window.localStorage.setItem('currentUserRole', result.roleId);
					window.localStorage.setItem('currentUserRoleLevel', result.roleType);
					dispatch('getRolePermissions', results);
				} else {
					dispatch('authLogout');
				}
				commit('SET_IS_LOGGED', true);
				return results;
			} catch (error) {
				commit('SET_INITIAL_LOADING_COMPLETED');
				throw error;
			}
		},
		getAccountData: async ({ commit, dispatch, state, rootGetters,rootState }, isInit) => {
			try {
				if(state.isLogged && !rootState.organizationStore.isSwitching) {
					return;
				}
				const results = await feathersClient.authenticate({
					strategy: 'loopback_auth',
					accessToken: window.localStorage.getItem('token'),
			  });
				commit('SET_INITIAL_LOADING_START');
				window.localStorage.setItem('token', results.accessToken);
				const account = results.user;
				commit('SET_ACCOUNT', account);
				const currentRoleLocal = window.localStorage.getItem('currentUserRole');// roleId
				// if(!currentRoleLocal){
				// 	dispatch('authLogout');
				// 	return;
				// }
				const currentRoleLocalLevel = window.localStorage.getItem('currentUserRoleLevel');
				commit('SET_CURRENT_USER_ROLE', currentRoleLocal);
				const result = account.newUserRoles?.filter((item) => (String(item.roleId) === String(currentRoleLocal)));
				window.localStorage.setItem('currentUserRoleLevel', currentRoleLocalLevel); // name of the role
				commit('SET_CURRENT_USER_ROLE_LEVEL', currentRoleLocalLevel);
				if (result.length > 0) {
					dispatch('getRolePermissions', results);
				}
				window.localStorage.setItem('account', JSON.stringify(account));
				commit('SET_IS_LOGGED', true);
				commit('SET_INITIAL_LOADING_COMPLETED');
				return results;
			  } catch (error) {
				console.log('Authentication error', JSON.stringify(error));
				commit('SET_INITIAL_LOADING_COMPLETED');
				dispatch('authLogout');
				throw error;
			  }
		}, // check for next
		authLogout: ({ commit }) => {
			commit('SET_TRAIN_HOSPITAL_STATUS', false);
			commit('SET_IS_LOGGED', false);
			commit('SET_FIREBASE_DB', null);
			commit('SET_NOTIFICATIONS', []);
			window.localStorage.removeItem('token');
			window.localStorage.removeItem('account');
			window.localStorage.removeItem('currentInstitutionId');
			window.localStorage.removeItem('currentUserRole');
			window.localStorage.removeItem('currentUserRoleType');
			window.localStorage.removeItem('currentUserRoleLevel');
			window.localStorage.removeItem('feathers-jwt');
			window.location.href = '/sign-in';
			axios.interceptors.request.use((request) => {
				request.headers.set('Authorization', null);
			});
		},
		reloadcomponent: async (context, itemsToUpdate) => {
			const { id, ...rest } = itemsToUpdate;
			const results = await feathersClient.service(`/api/v3/jobs/${id}`).create(rest);
			return results;
		},
		cleanUserInfo: ({ commit }) => {
			commit('SET_TRAIN_HOSPITAL_STATUS', false);
			commit('SET_IS_LOGGED', false);
			commit('SET_FIREBASE_DB', null);
			commit('SET_NOTIFICATIONS', []);
			window.localStorage.removeItem('token');
			window.localStorage.removeItem('account');
			window.localStorage.removeItem('currentInstitutionId');
			window.localStorage.removeItem('currentUserRole');
			window.localStorage.removeItem('currentUserRoleLevel');
			window.localStorage.removeItem('feathers-jwt');
		},

		changeStaffHospital: async ({ commit }, hospital) => {
			commit('SET_STAFF_SELECTED_HOSPITAL', hospital);
		},

		setScrollHiddenStatus: async ({ commit }, value) => {
			commit('SET_SCROLL_HIDDEN_STATUS', value);
		},
		completeInitialLoad: async ({ commit }) => {
			commit('SET_INITIAL_LOADING_COMPLETED');
		},
		updateAccountData: async ({ commit, context }, account) => {
			const url = '/api/v3/users/';
			const results = await feathersClient.service(url).patch(account.id, {
				...account,
				email: account.email.toLowerCase(),
			});
			commit('UPDATE_ACCOUNT', results);
			return results;
		},
		// updateAvatar: async (args, account) => {
		// 	const results = await Vue.http.post(
		// 		`/api/v1/users/${account.id}/avatar`,
		// 		 account,
		// 	);
		// 	return results.body;
		// },

		switchCurrentInstitution: ({ commit }, id) => {
			commit('SET_CURRENT_INSTITUTION_ID', id);
			commit('CLEAR_JOBS');
			window.localStorage.setItem('currentInstitutionId', id);
		},

		refreshoffer: async ({ commit, rootGetters }, payload) => {
			const data = await feathersClient.service('/api/v3/jobs').get(payload.jobId, { query: { $role: rootGetters.currentUserRole } });
			commit('REFRESH_OFFER', { index: payload.index, job: data });
			return data;
		},
		confirmApplication: async ({ rootGetters }, id) => {
			const url = '/api/v3/applications';
			const status = 'offered';
			const results = await feathersClient.service(url).patch(id, { status }, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},

		rejectApplication: async ({ rootGetters }, id) => {
			const url = '/api/v3/applications';
			const status = 'rejected';
			const results = await feathersClient.service(url).patch(id, { status }, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},

		sendJobOffer: async (context, options) => {
			// const url = '/api/v1/jobs/offer-to-nurse';
			const results = await feathersClient.service('/api/v3/jobs/offer-to-nurse').create(options);

			return results;
		},

		setUserFilter: ({ commit }, filter) => {
			commit('SET_USER_FILTER', filter);
		},
		setDefaultUserFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_USER_FILTER', filter);
		},
		setofferApplicableUserFilter: ({ commit }, filter) => {
			commit('SET_OFFER_APPLICABLE_USER_FILTER', filter);
		},
		setDefaultofferApplicableUserFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_OFFER_APPLICABLE_USER_FILTER', filter);
		},
		setUserPage: ({ commit, state }, page) => {
			const skip = (page - 1) * state.userPagination.limit;
			commit('SET_USER_PAGINATION', { skip });
			commit('SET_USER_FILTER', { skip });
		},
		setOfferApplicableUserPage: ({ commit, state }, page) => {
			const skip = (page - 1) * state.offerApplicableUserPagination.limit;
			commit('SET_OFFER_APPLICABLE_USER_PAGINATION', { skip });
			commit('SET_OFFER_APPLICABLE_USER_FILTER', { skip });
		},
		setApprovedUserPage: ({ commit, state }, page) => {
			const skip = (page - 1) * state.approvedUserPagination.limit;
			commit('SET_APPROVED_USER_PAGINATION', { skip });
			commit('SET_USER_FILTER', { skip });
		},
		setPendingUserPage: ({ commit, state }, page) => {
			const skip = (page - 1) * state.pendingUserPagination.limit;
			commit('SET_PENDING_USER_PAGINATION', { skip });
			commit('SET_USER_FILTER', { skip });
		},
		setDeclinedUserPage: ({ commit, state }, page) => {
			const skip = (page - 1) * state.declinedUserPagination.limit;
			commit('SET_DECLINED_USER_PAGINATION', { skip });
			commit('SET_USER_FILTER', { skip });
		},
		setBannedUserPage: ({ commit, state }, page) => {
			const skip = (page - 1) * state.bannedUserPagination.limit;
			commit('SET_BANNED_USER_PAGINATION', { skip });
			commit('SET_USER_FILTER', { skip });
		},
		setChangedUserPage: ({ commit, state }, page) => {
			const skip = (page - 1) * state.changedUserPagination.limit;
			commit('SET_CHANGED_USER_PAGINATION', { skip });
			commit('SET_USER_FILTER', { skip });
		},
		setInstitution: ({ commit }, institutionId) => {
			commit('SET_CURRENT_INSTITUTION_ID', institutionId);
		},

		loadUsersCountByStatusAndInstitution: async ({ commit, context }, filter) => {
			const url = '/api/v3/users';
			const results = await feathersClient.service(url).find({ query: filter });
			// commit('SET_APPROVED_USER_PAGINATION', { total: results.approvedCount });
			// commit('SET_PENDING_USER_PAGINATION', { total: results.pendingCount });
			// commit('SET_DECLINED_USER_PAGINATION', { total: results.declinedCount });
			// commit('SET_BANNED_USER_PAGINATION', { total: results.bannedCount });
			// commit('SET_CHANGED_USER_PAGINATION', { total: results.changedCount });
			return results;
		},

		loadJobs: async ({ commit, rootGetters ,state}, filter) => {
			const url = '/api/v3/jobs';
			const status = filter.status;
			
			if (status && status !== undefined && status !== null) {
				delete filter.$managerBooked;
				delete filter.$managerCompleted;
				delete filter.$vacant;
				delete filter.$status;
				if (status === 'noLog' || status === 'readyForApprove' || status === 'approved') {
					filter.$managerCompleted = true;
					filter.$status = status;
				} else if (status === 'booked') {
					filter.$managerBooked = true;
				} else {
					filter.$vacant = true;
				}
			} else {
				filter.$vacant = true;
			} // shhift-manager
			// Normalize and compare `dateTo` as a timestamp (end of day) using moment
			//changes done for past shifts start
			const now = moment().format('YYYY-MM-DD');
		
			if(filter.$dateTo !=undefined){
              filter.dateTo=filter.$dateTo;
			}
			
			if (filter.$dateTo < now || filter.dateTo < now) {
				// If caller explicitly requested filled reasons for past dates, prefer that
				if (filter?.$completedWithFilledReason === true) {
				
					delete filter.$completedWithUnfilledReason;
					filter.$completedWithFilledReason = true;
					filter.dateFrom = filter.$dateFrom || filter.dateFrom;
					filter.dateTo= filter.$dateTo || filter.dateTo;
					delete filter.$dateFrom;
					delete filter.$dateTo;
				} else {
					// Past date and no filled flag -> return unfilled reasons by default
					
					delete filter.$completedWithFilledReason;
					filter.$completedWithUnfilledReason = true;
					filter.dateFrom = filter.$dateFrom || filter.dateFrom;
					filter.dateTo= filter.$dateTo || filter.dateTo;
					delete filter.$dateFrom;
					delete filter.$dateTo;
				}
			}
			else{
			
				delete filter.$completedWithFilledReason;
				delete filter.$completedWithUnfilledReason;
				delete filter.dateFrom;
					delete filter.dateTo;
			}
			//changes done for past shifts end
			filter.shiftStatus = state.jobShiftStatus;
			const fields = [ 	
				'applications',
				'careLocations',
				'manager',
				'rateEscalationHistory',
				'hardToFill',
				'rateEscalationComments',
				'jobPersona',
				'optimaBookingReference',
			];
			if (status === 'booked') {
				fields.push('SkillScore'); // Replace with the actual field name
			}
			 await feathersClient.service(url).find({
				query: {
					$role: rootGetters.currentUserRole,
					$personaNameWithCapability: true,
					fields: fields,
					...filter,
				},
			}).then((results) => {
				if(rootGetters?.currentUserRolePermissions?.includes('VIEW_RATE_ESCALATED_SHIFTS')){
					const filteredArray = results?.data?.filter(obj => {
						// Check for the existence of rateEscalationHistory and at least one element
						if (obj?.rateEscalationHistory && obj?.rateEscalationHistory?.length > 0) {
							// Get the last history entry
							const lastHistory = obj.rateEscalationHistory[obj.rateEscalationHistory.length - 1];
							// Return true if the status of the last history entry is "INTERMEDIATE_APPROVED"
							const hasIntermediateApprovedStatus = lastHistory?.value?.status === "INTERMEDIATE_APPROVED";
							// Check for conditions related to applications
							const hasValidApplications = (
								(obj?.applications && obj?.applications.length === 0) ||
								(obj?.applications?.some(app =>
									app.active &&
									(app.status === 'rejected' ||
									 app.status === 'rejectedByNurse' ||
									 app.status === 'skipped')
								))
							);

							// Return true if both conditions are met
							return hasIntermediateApprovedStatus && hasValidApplications;
						}

						// Return false if rateEscalationHistory is not present or is empty
						return false;
					});
					commit('SET_JOBS', filteredArray);
					const totalCount = filteredArray.length;
					commit('SET_JOBS_PAGINATION', { total: totalCount });

				}
				else if(rootGetters?.currentUserRolePermissions?.includes('VIEW_NON_PARTICIPANTS_SHIFTS')){
					const filteredArray = results?.data?.filter(obj => {
						const hasValidApplications = (
							(obj?.applications && obj?.applications.length === 0) ||
							(obj?.applications?.every(app =>
								app.active &&
								(app.status === 'rejected' ||
								 app.status === 'rejectedByNurse' ||
								 app.status === 'skipped')
							))
						);
						return hasValidApplications;
					});
					commit('SET_JOBS', filteredArray);
					const totalCount = filteredArray.length;
					commit('SET_JOBS_PAGINATION', { total: totalCount });

				}
				else{
					commit('SET_JOBS', results.data);
					const totalCount = results.total;
					commit('SET_JOBS_PAGINATION', { total: totalCount });
				}
			});
		},
		hideJobById: async ({ commit }, jobId) => {
			commit('HIDE_JOB', jobId);
		},

		loadProductConfigurations: async () => {
			const url = '/api/v3/product-configuration';
			const results = await feathersClient.service(url).find({
				query: { $paginate: false },
			});
			return results;
		},
		loadProductConfigurationsById: async (context, id) => {
			const url = '/api/v3/product-configuration/';
			const results = await feathersClient.service(url).get(id);
			return results;
		},
		exportUserPreferences: async (context, { dateFrom, dateTo }) => {
			// const url = '/api/v1/users/user-preferences/export';
			// const results = await feathersClient.service(url).find({
			// 	query: { dateFrom, dateTo },
			// });
			// return results;
		},
		getAvailabilityPreferences: async () => {
			// const url = '/api/v1/availabilityPreferences';
			const results = await feathersClient.service('/api/v3/availability-preferences').find({});
			return results.data;
		},
		getMotivationPreferences: async () => {
		//	const url = '/api/v1/motivationPreferences';
			const results = await feathersClient.service('/api/v3/motivation-preferences').find({});
			return results.data;
		},

		getPreferencesIntroduction: async () => {
			// const url = '/api/v1/preferencesIntroduction';
			const results = await feathersClient.service('/api/v3/preference-introduction').find({});
			return results.data;
		},
		createFeedbackSettings: async (context, feedbacksettings) => {
			const results = await feathersClient.service('/api/v3/departmentFeedbackSettings').create(feedbacksettings, {
				// query:{
				// 	$role: rootGetters.currentUserRole,
				// }
			});

			return results;
		},
		createFeedbackQuestions: async (context, feedbackquestions) => {
			const results = await feathersClient.service('/api/v3/feedback-questions').create(feedbackquestions);
			return results;
		},
		createProductConfiguration: async ({ rootGetters }, productConfig) => {
			const url = '/api/v3/product-configuration';
			const results = await feathersClient.service(url).create(productConfig, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		createPreferencesIntroduction: async (context, preferencesintroduction) => {
			const results = await feathersClient.service('/api/v3/preference-introduction').create(preferencesintroduction, {

			});
			return results;
		},

		getfeedbackSettingsOfArea: async (context, query) => {
			const url =	'/api/v1/departmentFeedbackSettings/feedbackSettingsOfArea';

			const results = await feathersClient.service('/api/v3/departmentFeedbackSettings').find({

			});
			return results.data;
		},
		getfeedbackQuestions: async (context, query) => {
			const results = await feathersClient.service('/api/v3/feedback-questions').find({

			});
			return results.data;
		},

		getSignedUrl: async (context, key) => {
			const url = `/api/v1/uploads/signedurl/${key}`;
			// signedurls
			const results = await feathersClient.service('/api/v3/signedurls').find({
				query: {
					key: key,
				},
			});
			return results;
		},
		getRosterSignedUrl: async (context, key) => {
			const url = `/api/v1/uploads/signedurl/${key}`;
			// signedurls
			const results = await feathersClient.service('/api/v3/signedurls').find({
				query: {
					key: key,
					$uploadRosterShifts: true,
				},
			});
			return results;
		},
		updateFeedbackSettings: async (context, feedbackSettings) => {
			const results = await feathersClient.service('/api/v3/departmentFeedbackSettings').patch(feedbackSettings.id, feedbackSettings, {
			});
			return results;
		},
		updateFeedbackQuestions: async ({ rootGetters }, feedbackquestions) => {
			const results = await feathersClient.service('/api/v3/feedback-questions').patch(feedbackquestions.id, feedbackquestions, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		updateProductConfiguration: async ({ rootGetters }, productConfig) => {
			const url = '/api/v3/product-configuration/';
			const results = feathersClient.service(url).patch(productConfig.id, productConfig, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},

		updatePreferencesIntroduction: async ({ rootGetters }, preferencesintroduction) => {
			const results = await feathersClient.service('/api/v3/preference-introduction').patch(preferencesintroduction.id, preferencesintroduction, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},

		refreshRatesTablePage: async ({ state, dispatch }) => {
			await dispatch('loadRateJobs');
		},
		setSelectedJob: ({ commit }, data) => {
			commit('SET_SELECTED_JOB', data);
		},
		editJob: ({ commit, state }, data) => {
			const { index, key, value } = data;
			const { jobs } = state;
			const newJobs = jobs.map((job, i) => (i === index ? { ...job, [key]: value } : job));
			commit('SET_JOBS', newJobs);
		},
		updateJobs({ commit }, newJobs) {
			commit('SET_JOBS', newJobs);
		},
		patchJobs: ({ commit, state }, jobs) => {
			const newJobs = [...state.jobs];
			jobs.forEach((jobItem) => {
				const index = state.jobs.findIndex(
					(job) => job.id === jobItem.id,
				);
				if (index > -1) {
					newJobs[index] = jobItem;
				}
			});
			commit('SET_JOBS', newJobs);
		},
		editJobRateEscaltionValue({ commit }, jobs) {
			commit('UPDATE_RATE_ESCALATION', jobs);
		},
		editMultipleJobs: ({ commit }, data) => {
			commit('UPDATE_JOBS_PARAMS', data);
		},

		deleteProductConfiguration: async ({ rootGetters }, id) => {
			const url = '/api/v3/product-configuration';
			const results = await feathersClient.service(url).remove(id, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		setSnoozeTime: async ({ rootGetters }, data) => {
			const results = await feathersClient.service('/api/v3/users').patch(data.id, data, {

			});
		},

		// loadJobTitlesForInstitution: async (context, institutionId) => {
		// 	const url = '/api/v1/job-titles';
		// 	const { data, error } = await Vue.http.get(url, {
		// 		params: { institutionId },
		// 	});
		// 	if (error) {
		// 		throw error;
		// 	}
		// 	return data;
		// },
		createJobs: async ({ rootGetters, dispatch }, jobPostData) => {
			const url = '/api/v3/jobs';
			const jobWithSkills = await dispatch('jobPostingStore/createJobSkills');
			// eslint-disable-next-line no-plusplus
			for (let j = 0; j < jobPostData.jobData.length; j++) {
				jobPostData.jobData[j].jobSkills = jobWithSkills;
			}
			const results = await feathersClient.service(url).create(jobPostData,
				{
					query:
					{
						$role: rootGetters.currentUserRole,
					},
				});
			return results;
		},
		loadJobsUnfilled: async ({ commit, rootGetters }, filter) => {
			const url = '/api/v3/manager-jobs-grouped-by-date';
			const result = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, ...filter } }).then((results) => {
				const res = results.jobs;
				commit('SET_JOBS_UNFILLED', res || {});
				return results;
			});
		
			return result;
		},
		clearJobs: ({ commit }) => {
			commit('CLEAR_JOBS');
		},
		clearJobsUnfilled: ({ commit }) => {
			commit('SET_JOBS_UNFILLED', {});
		},
		loadJobFull: async ({ rootGetters, commit }, id) => {
			const url = '/api/v3/jobs';
			const results = await feathersClient.service(url).get(id, {
				query: {
					$role: rootGetters.currentUserRole, $showHierarchy: true, fields: [ 'applications', 'manager', 'careLocations', 'weightSettings', 'shiftincentives', 'rateEscalationHistory', 'hardToFill', 'rateEscalationComments', 'jobPersona', 'optimaBookingReference'],
				},
			});
			if (results) {
				commit('SET_SELECTED_JOB', results);
				commit('DEFAULT_WEIGHT_SETTINGS', results.matchSettings);
			}
			return results;
		},
		loadJobFullById: async ({ rootGetters, commit }, id) => {
			const url = '/api/v3/jobs';
			const results = await feathersClient.service(url).get(id, {
				query: {
					$role: rootGetters.currentUserRole, fields: ['careLocations'],
				},
			});
			if (results) {
				commit('SET_SELECTED_JOB', results);
				commit('DEFAULT_WEIGHT_SETTINGS', {});
			}
			return results;
		},
		loadUserDetails: async (args, id) => {
			const url = '/api/v3/users/';
			const results = feathersClient.service(url).get(id, { query: { fields: ['roles', 'userSkills'] } });
			return results;
		},
		loadUserSkills: async (args, id) => {
			const url = '/api/v3/users';
			const results = await feathersClient.service(url).get(id, { query: { fields: ['userSkills'] } });
			delete results.areas; delete results.commutePreference;
			delete results.jobTitles; delete results.userRoles; delete results.latitude; delete results.longitude; delete results.isFlexibleToMove;

			return results;
		},

		getJobById: async ({ rootGetters }, id) => {
			const url = '/api/v3/jobs/';
			const results = feathersClient.service(url).get(id, { query: { $role: rootGetters.currentUserRole } }).then((res) => res);
			return results;
		},

		deleteJobById: async ({ rootGetters }, id) => {
			const results = await feathersClient.service('/api/v3/jobs/').remove(id, {
				query: {
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},

		// saveTimeIntervalsTable: async (context, { id, body }) => {
		// 	const url = `/api/v1/institutions/${id}/time-intervals`;
		// 	const results = await Vue.http.post(url, {
		// 		definitionOfTime: body,
		// 	});
		// 	return results;
		// },
		// getTimeIntervalsTable: async (context, id) => {
		// 	const url = `/api/v1/institutions/${id}/time-intervals`;
		// 	const results = await Vue.http.get(url);
		// 	return results.body;
		// },

		updateJob: async ({ rootGetters }, itemsToUpdate) => {
			const { id, ...rest } = itemsToUpdate;
			if (!id || id === null) throw new Error('updateJob: missing job id'); // guard against multi-patch
			try {
				const results = await feathersClient
					.service('/api/v3/jobs')
					.patch(id, rest, { query: { $role: rootGetters.currentUserRole } });
				return results;
			} catch (err) {
				console.error('updateJob failed', err);
				throw err;
			}
		},

		getAvailabilityCalendar: async ({ rootGetters }, userId, dateFrom, dateTo) => {
			const results = await feathersClient.service('/api/v3/date-availability').find({
				query: {
					$role: rootGetters.currentUserRole,
					userId: userId,
					dateFrom: dateFrom,
					dateTo: dateTo,
					$paginate: false,
				},

			});
			return results;
		},
		setPath: ({ commit, dispatch }, path) => {
			commit('SET_PATH', path);
			dispatch('loadItems', path);
		},
		refresh({ state, dispatch }) {
			dispatch('setPath', state.path);
		},
		getFirebaseDb: async ({ commit }) => {
			const db = await initFirebaseDbConnection();
			commit('SET_FIREBASE_DB', db);
			await firebaseAuth(); // Auth Firebase.
		},
		setJobsForApproval: ({ commit }, jobs) => {
			commit('SET_JOBS_FOR_APPROVAL', jobs);
		},

		startInitialLoader: ({ commit }) => {
			commit('SET_INITIAL_LOADING_START');
		},
		endInitialLoader: ({ commit }) => {
			commit('SET_INITIAL_LOADING_COMPLETED');
		},

		setRangeType: ({ commit }, rangeType) => {
			commit('SET_RANGE_TYPE', rangeType);
		},
		setJobsFilter: ({ commit }, filter) => {
			commit('SET_JOBS_FILTER', filter);
		},

		setThresholdFactorsFilter: ({ commit }, filter) => {
			commit('SET_THRESHOLD_FACTORS_FILTER', filter);
		},
		setDepartmentsFilter: ({ commit }, filter) => {
			commit('SET_DEPARTMENTS_FILTER', filter);
		},
		setJobsByKey: ({ commit }, data) => {
			commit('SET_JOBS_FILTER_BY_KEY', data);
		},
		 setDefaultJobsFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_JOBS_FILTER', filter);
		},
		setDefaultThresholdFactorsFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_THRESHOLD_FACTORS_FILTER', filter);
		},
		patchJobsFilterByKey: ({ commit }, data) => {
			commit('UPDATE_JOBS_FILTER_BY_KEY', data);
		},
		updateJobsFilterByKey: ({ commit }, data) => {
			commit('UPDATE_JOBS_FILTER_BY_KEY', data);
		},
		setJobsPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.jobsPagination.$limit;
			commit('SET_JOBS_PAGINATION', { $skip });
			commit('SET_JOBS_FILTER', { $skip });
		},

		setThresholdFactorsPage: ({ commit, state }, page) => {
			const skip = (page - 1) * state.thresholdFactorsPagination.limit;
			commit('SET_THRESHOLD_FACTORS_PAGINATION', { skip });
			commit('SET_THRESHOLD_FACTORS_FILTER', { skip });
		},
		setDepartmentsPage: ({ commit, state }, page) => {
			const skip = (page - 1) * state.departmentsPagination.limit;
			commit('SET_DEPARTMENTS_PAGINATION', { skip });
			commit('SET_DEPARTMENTS_FILTER', { skip });
		},
		setPredictionsPage: ({ commit, state }, page) => {
			const skip = (page - 1) * state.predictionsPagination.limit;
			commit('SET_PREDICTIONS_PAGINATION', { skip });
			commit('SET_PREDICTIONS_FILTER', { skip });
		},
		setPredictionsFilter: ({ commit }, filter) => {
			commit('SET_PREDICTIONS_FILTER', filter);
		},

		setCalendarDate: ({ commit }, date) => {
			commit('SET_CALENDAR_DATE', date);
		},

		verifyUserEmail: (context, data) => {
			const url = '/api/v3/authmanagement';
			return feathersClient.service(url).create(data);
		},
	},
});

export default store;
